function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.8906 2.85938H2.10938C0.947719 2.85938 0 3.80606 0 4.96875V19.0312C0 20.19 0.9435 21.1406 2.10938 21.1406H21.8906C23.0494 21.1406 24 20.1971 24 19.0312V4.96875C24 3.81 23.0565 2.85938 21.8906 2.85938ZM21.5993 4.26562L12.0447 13.8203L2.40745 4.26562H21.5993ZM1.40625 18.7401V5.25323L8.1787 11.9676L1.40625 18.7401ZM2.40061 19.7344L9.17733 12.9577L11.5519 15.3118C11.8268 15.5843 12.2703 15.5835 12.5441 15.3097L14.8594 12.9944L21.5994 19.7344H2.40061ZM22.5938 18.74L15.8537 12L22.5938 5.25994V18.74Z"
});

function SvgChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.efcaa186.svg";
export { ForwardRef as ReactComponent };